<template>
  <router-link
    class="project__content-item"
    :to="{
      name: 'project',
      params: { id: project.id },
    }"
    @click="goToTop()"
  >
    <div ref="cart" :id="project.id" class="box"> 
      <img
        class="project__content-item-img"
        title="Проекты CENTRIS MEDIA"
        :src="require('@/assets/images/projects/' + project.img)"
        alt="Проекты CENTRIS MEDIA"
      />
      <video
        ref="cartVideo"
        class="project__content-item-video"
        :class="{ active: itemHover }"
        :src="require('@/assets/video/' + project.video)"
        muted
        loop
        playsinline
      ></video>
      <div class="project__content-item_name" :class="{ active: itemHover }">
        <div
          class="project__content-item_name-logo"
          :class="{ active: itemHover }"
        >
          <img    class="project__content-item_name-logo-img"
            title="Проекты CENTRIS MEDIA"
            :src="require('@/assets/images/logo/' + project.title)"
            alt="Проекты CENTRIS MEDIA"
          />
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    project: Object,
  },
  data() {
    return {
      itemHover: false,
      viewportWidth: window.innerWidth,
    };
  },
  methods: {
    registerEvent() {
      this.$refs.cart.addEventListener("mouseover", () => {
        this.itemHover = true;
        this.$refs.cartVideo.play();
      });
      this.$refs.cart.addEventListener("mouseout", () => {
        this.itemHover = false;
        this.$refs.cartVideo.pause();
      });
    },
    goToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.registerEvent();
    window.scrollTo(0, 0);
    if (window.innerWidth <= 768) {
      let options = {
        rootMargin: "0px",
        threshold: "0.9"
      };
      let callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              this.itemHover = true;
              this.$refs.cartVideo.play();
            }, 1000);
          } else {
            this.itemHover = false;
            this.$refs.cartVideo.pause();
          }
        });
      };
      let observer = new IntersectionObserver(callback, options);
      let t = this.$refs.cart;
      observer.observe(t);
    }
  },
  computed: {
    pageData() {
      return this.$store.getters.getPageData(this.$route.params.id);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/grid/grid";
.project__content {
  width: 100%;
  &-items {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-bottom: 20px;
    @media (max-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }
    @media (max-width: 768px) {
      grid-template-columns: repeat(1, 1fr);
      gap: 20px;
      overflow: hidden;

      &.hide {
        display: none;
        gap: 20px;
        overflow: hidden;
      }
    }
  }
  &-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    @media (max-width: 768px) {
      max-width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .box{
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
    }
    &_name {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      // display: flex;
      // flex-direction: column;
      // justify-content: flex-end;
      // @include adaptivPaddinglg(25, 25, 25, 20, 22, 22, 22, 16);
      @media (max-width: 768px) {
        @include adaptivPaddingmd(20, 20, 40, 20, 10, 10, 30, 16);
      }
      &-logo {
        @include adaptivWidthLg(100, 90);
        @include adaptivHeightlg(65, 60);
        &.active {
          display: none;
        }
        @media (min-width: 1921px) {
          max-width: 100px;
        }
        @media (max-width: 768px) {
          @include adaptivWidthmd(150, 100);
          @include adaptivHeightmd(100, 70);
        }
        &-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    &-video {
      width: 101%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      // display: none;
      opacity: 0;
      &.active {
        // display: block;
        width: 100%;
        opacity: 1;
        transition: 0.5s;
        background: #262626;
      }
      @media (max-width: 768px) {
        overflow: hidden;
      }
    }
    &-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-btn {
    display: none;
    @media (max-width: 768px) {
      margin: 0 auto;
      margin-top: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      @include adaptivWidthmd(422, 181);
      width: 100%;
      @include adaptivHeightmd(65, 46);
      background: #7338d8;
      color: #fff;
      @include adaptiv-fontlg(24, 18);
      @include adaptiv-lineHeightlg(24, 18);
      text-transform: uppercase;
      font-family: "Helvetica-thin";
    }
    &.close {
      display: none;
    }
  }
}
</style>